module.exports = __webpack_public_path__ + "img/skale-dark.b6ced818.svg";